/* eslint-env browser */
import React from 'react';
import TimelineComponent from './TimelineComponent';

class AUTimelineComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeline: [],
      text: {
      },
    };
  }

  componentWillMount() {
    this.setState({ timeline: window.items });
    this.setState({ text: window.text });
  }

  componentDidMount() {
    if (window.matchMedia('(max-width: 600px)').matches) {
      $('.periods-navigation').css('display', 'block');
    } else {
      $('.periods-navigation').css('display', 'none');
    }
  }


  render() {
    return [
      <div className="App" key="app">
        <TimelineComponent
          key="tidslinje"
          timeline={this.state.timeline}
          text={this.state.text}
          modal="false"
        />
      </div>,
    ];
  }
}
export default AUTimelineComponent;
